export default __webpack_public_path__ + "static/media/the_times_group_loader.27c38451.png";